const getDefaultState = () => {
  return {
    templates: []
  };
};
const state = getDefaultState();

const getters = {
  getScenarioTemplateType: (state) => (type) => {
    return state.templates.find((e) => e.scenarioTemplateType === type);
  }
};

const mutations = {
  addTemplate(state, template) {
    state.templates.push(template);
  }
};

export default {
  state,
  getters,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/chatbotTemplate/index.js